import { useCallback } from 'react'
import { FileResponse } from "shared/api"

import { FormDialog } from 'components/dialog/form'

import { NotificationResult, usePostNotification } from "interface/notification"
import { useNotificationForm, NotificationForm } from "../form"

type AddNotificationDialogProps = {
  onClose: () => void
	onAddNotification: (result: NotificationResult, logo?: FileResponse) => void
}
export const AddNotificationDialog = ({
  onClose,
  onAddNotification,
}: AddNotificationDialogProps) => {
  const onPosted = useCallback(
    (result: NotificationResult) => {
      onAddNotification(result)
      onClose()
    },
    [onAddNotification, onClose]
  )
  const [addNotificationState, addNotification] = usePostNotification({ onPosted })
  const form = useNotificationForm({ onSubmit: addNotification })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="新規お知らせを登録"
      isLoading={addNotificationState.posting}
      error={addNotificationState.error}
      body={<NotificationForm {...form}/>}
      submitLabel="登録"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
